import { render, staticRenderFns } from "./Tipocliente.vue?vue&type=template&id=5dd3aa72&scoped=true&"
import script from "./Tipocliente.vue?vue&type=script&lang=js&"
export * from "./Tipocliente.vue?vue&type=script&lang=js&"
import style0 from "./Tipocliente.vue?vue&type=style&index=0&id=5dd3aa72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd3aa72",
  null
  
)

export default component.exports